import { useFormContext } from 'react-hook-form';
import Stack from '@mui/system/Stack/Stack';
import { mapCompanySize, mapIndustry, mapCountry, mapLanguage } from 'tdc-web-backend/enums/enums';
import BaseInputLabel from '../../../../components/custom-inputs/BaseInputLabel';
import CustomInput from '../../../../components/custom-input/CustomInput';
import { Typography } from '@mui/material';

const DetailsBuyer = () => {
  const { watch } = useFormContext();
  const aiAssistanceEnabled = watch('aiAssistanceEnabled');
  return (
    <Stack spacing={2}>
      {aiAssistanceEnabled && (
        <Stack
          sx={{
            bgcolor: 'primaryLight.50',
            p: 2,
            borderRadius: '4px',
            mb: 3,
            border: '1px solid',
            borderColor: 'secondaryBlue.300',
          }}
        >
          <Typography color="primaryDark.600" sx={{ fontSize: '14px', fontWeight: 600, mb: 1 }}>
            ✓ Company data has been populated.
          </Typography>
          <Typography color="primaryDark.500" sx={{ fontSize: '12px', fontStyle: 'italic' }}>
            Please review and verify all gathered data before proceeding to the next step.
          </Typography>
        </Stack>
      )}
      <BaseInputLabel text="company details" />

      <Stack flexDirection="row" sx={{ margin: '0 0 32px 0' }}>
        <Stack
          spacing={3}
          width="50%"
          pr={3}
          sx={{ borderRight: '1px solid', borderColor: 'secondaryBlue.100' }}
        >
          <CustomInput
            input={<CustomInput.Autocomplete />}
            name="details.targetIndustries"
            label="company industry"
            placeholder="Select industry"
            choices={mapIndustry}
            required
            multiple
            withChips
          />

          <CustomInput
            input={<CustomInput.Autocomplete />}
            name="details.targetCountries"
            label="Target markets"
            placeholder="Select country"
            choices={mapCountry}
            required
            multiple
            withChips
          />
        </Stack>

        <Stack spacing={3} width="50%" pl={3}>
          <CustomInput
            input={<CustomInput.Autocomplete />}
            name="details.companySize"
            label="Company size"
            placeholder="Select size"
            choices={mapCompanySize}
            required
          />

          <CustomInput
            input={<CustomInput.Autocomplete />}
            name="details.languages"
            label="Working languages"
            placeholder="Select languages"
            choices={mapLanguage}
            multiple
            withChips
            required
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default DetailsBuyer;
